import {HTTP} from "../http";
import LogEntry from "@/model/LogEntry";

class LogService {
  async get(timestamp, lines) {
    // create query params
    const searchParams = new URLSearchParams();
    if (timestamp) {
      searchParams.append('afterDate',timestamp);
    }
    if (lines) {
      searchParams.append('lines', lines);
    }

    const logsRaw = await HTTP.get(`api/logs?${searchParams.toString()}`);
    return logsRaw.data.log.map(item => this._logEntryFromJson(item));
  }

  /**
   * @param json
   * @returns {LogEntry}
   * @private
   */
  _logEntryFromJson(json) {
    return new LogEntry(
      json.date,
      json.type,
      json.thread,
      json.logger,
      json.message,
    )
  }
}

/**
 *
 * @type {LogService}
 */
export const logService = new LogService();
